import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var SquareImage = function SquareImage() {
  return import('~/components/atoms/Product/SquareImage.vue');
};

export default {
  name: 'ZoomableImage',
  components: {
    SquareImage: SquareImage
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isPanning: false,
      tapFirst: false,
      tapTimeout: null,
      scale: 1,
      clientX: 0,
      clientY: 0,
      diffX: 0,
      diffY: 0,
      height: 1,
      width: 1
    };
  },
  computed: {
    zoomStyle: function zoomStyle() {
      var rx = 100 * (this.diffX / this.width);
      var ry = 100 * (this.diffY / this.height);
      var limit = this.scale === 4 ? 150 : 50;
      var x = Math.min(Math.max(rx, -limit), limit);
      var y = Math.min(Math.max(ry, -limit), limit);
      return {
        transform: "translate(".concat(x, "%, ").concat(y, "%) scale(").concat(this.scale, ")")
      };
    }
  },
  watch: {
    index: function index(newValue) {
      if (newValue) {
        this.resetZoom();
      }
    }
  },
  mounted: function mounted() {
    var _this$$refs$zoomable = this.$refs.zoomable,
        offsetHeight = _this$$refs$zoomable.offsetHeight,
        offsetWidth = _this$$refs$zoomable.offsetWidth;
    this.height = offsetHeight;
    this.width = offsetWidth;
  },
  methods: {
    onTap: function onTap() {
      var _this = this;

      // onTap function: differentiates tap from double tap
      if (!this.tapFirst) {
        this.tapFirst = true;
        this.tapTimeout = setTimeout(function () {
          _this.tapFirst = false;
        }, 500);
      } else {
        this.tapFirst = false;
        this.tapTimeout = clearTimeout(this.tapTimeout);

        if (this.scale < 4) {
          this.scale *= 2;
        } else {
          this.resetZoom();
        }
      }
    },
    startMove: function startMove(event) {
      if (this.scale !== 1) {
        event.stopPropagation();
        this.isPanning = true;
        this.disableWindowScroll();
        this.$emit('start-zoom-panning');
      }
    },
    moveZoom: function moveZoom(event) {
      if (this.scale === 1) {
        return;
      }

      var _event$changedTouches = _slicedToArray(event.changedTouches, 1),
          _event$changedTouches2 = _event$changedTouches[0],
          clientX = _event$changedTouches2.clientX,
          clientY = _event$changedTouches2.clientY;

      var diffX = this.clientX && clientX - this.clientX;
      var diffY = this.clientY && clientY - this.clientY;
      this.clientX = clientX;
      this.clientY = clientY;
      this.diffX += diffX;
      this.diffY += diffY;
    },
    endMove: function endMove(event) {
      if (this.isPanning) {
        event.stopPropagation();
        this.clientX = 0;
        this.clientY = 0;
        this.isPanning = false;
        this.enableWindowScroll();
        this.$emit('end-zoom-panning');
      }
    },
    resetZoom: function resetZoom() {
      this.clientX = 0;
      this.clientY = 0;
      this.diffX = 0;
      this.diffY = 0;
      this.scale = 1;
    }
  }
};